import en from '../../../lang/en-us';
import { connect } from 'react-redux';
import { RootStateType } from '../../../redux-store/reducers';
import { getUnclaimedPayouts } from '../../../redux-store/actions/portfolio';
import {
    UNCLAIMED_PAYOUTS_DATA,
    UNCLAIMED_PAYOUT_PAYLOAD,
} from '../../../redux-store/types/portfolio';
import { useEffect, useState } from 'react';
import NoFoliosFound from '../makeNct/NoFoliosFound';
import { IconButton, Table, TableBody, TableCell, TableHead, TableRow } from '@material-ui/core';
import { useTableWithCollapse } from '../../../lib/DataTable/customHooks';
import { TableColumn } from '../../../lib/DataTable/types';
import { TableWithCollapse } from '../../../lib/DataTable';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import { formatAsIndianCurrency } from '../../../utils/currency';
import { DEBT, EQUITY, LIQUID, OTHER } from '../../../utils/constants';

const { unclaimedPayouts } = en;

const columns: TableColumn[] = [
    {
        field: 'id',
        headerName: 'S No.',
        valueGetter: ({ index = 0 }) =>
            (index + 1).toLocaleString('en-US', {
                minimumIntegerDigits: 2,
                useGrouping: false,
            }),
    },
    { field: 'folio', headerName: 'FOLIO' },
    {
        field: 'schemeDescription',
        headerName: 'SCHEME NAME',
        filterBy: true,
        filterKey: 'schemeDescription',
        filterHeader: 'Fund House',
    },
    { field: 'transactionType', headerName: 'TRANSACTION TYPE' },
    { field: 'amount', headerName: 'AMOUNT' },
    {
        field: 'action',
        headerName: 'ACTION',
        renderCell: ({ setCollapse, collapse }) => {
            return (
                <IconButton
                    aria-label="expand row"
                    size="small"
                    onClick={(e) => {
                        e.stopPropagation();
                        setCollapse(!collapse);
                    }}
                >
                    {collapse ? (
                        <>
                            <span>Hide</span>
                            <KeyboardArrowUpIcon />
                        </>
                    ) : (
                        <>
                            <span>View</span>
                            <KeyboardArrowDownIcon />
                        </>
                    )}
                </IconButton>
            );
        },
    },
    {
        isFilter: true,
        field: 'assetType',
        headerName: 'Category',
        filterBy: true,
        renderStaticFilters: [EQUITY, LIQUID, DEBT, OTHER],
    },
];

function ViewUnclaimedPayouts(props: any) {
    const [rowData, setRowdata] = useState<UNCLAIMED_PAYOUTS_DATA[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const { tableRows, tableColumns, ...rest } = useTableWithCollapse<UNCLAIMED_PAYOUTS_DATA[]>({
        rows: rowData,
        columns,
        loading,
    });
    useEffect(() => {
        async function callApi() {
            setLoading(true);
            try {
                const payload: UNCLAIMED_PAYOUT_PAYLOAD = {
                    pan: props.pan,
                    mobile: props.mobile,
                    pekrn: props.pekrn,
                    reqId: props.reqId,
                };
                const { body: payoutsDetails = {} } = await props.getUnclaimedPayouts(payload);
                const { success: consolidationData = [] } = payoutsDetails || [];
                setLoading(false);
                setRowdata(consolidationData);
            } catch (err: any) {
                alert(err.message);
            } finally {
                setLoading(false);
            }
        }
        callApi();
        return () => { };
    }, []);

    const _renderCollapse = ({ row }: { row: UNCLAIMED_PAYOUTS_DATA }) => {
        return (
            <Table size="small" aria-label="purchases">
                <TableHead>
                    <TableRow>
                        <TableCell align="right">Duration</TableCell>
                        <TableCell align="right">Amount</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {row?.duration?.map((historyRow: any) => (
                        <TableRow key={historyRow.date}>
                            <TableCell align="right">
                                <img src="/images/calender.svg" alt="icon" />
                                {historyRow.fromPeriod} - {historyRow.toPeriod}
                            </TableCell>
                            <TableCell align="right">
                                {formatAsIndianCurrency(historyRow.amount)}
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        );
    };

    return (
        <div className="curved-bg">
            <h2 className="heading">
                <a
                    href="#"
                    style={{
                        visibility: 'hidden',
                    }}
                >
                    <img src="/images/left-arrow-black.svg" alt="icon" />
                </a>
                {unclaimedPayouts.mainHeading}
            </h2>
            <div className="curved-bg-content curved-bg-table-outer">
                <div className="curved-bg-content-table">
                    {/* <h5> {unclaimedPayouts.subHeading}</h5> */}
                    <div className="curved-table-content">
                        <div className="curved-table-content-bottom unclaimed-payout-table-collapse">
                            {tableRows.length || loading ? (
                                <TableWithCollapse
                                    columns={tableColumns}
                                    rows={tableRows}
                                    renderCollapse={_renderCollapse}
                                    {...rest}
                                />
                            ) : (
                                <NoFoliosFound info={'No Folios Found'} />
                            )}
                        </div>
                    </div>
                </div>
                <div className="curved-bg-content-inner-bottom"></div>
            </div>
        </div>
    );
}

export default connect(
    ({ authReducer, portfolio }: RootStateType) => ({ ...authReducer, ...portfolio }),
    { getUnclaimedPayouts },
)(ViewUnclaimedPayouts);
